// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterStack {
    justify-content: space-between;
}

.allCheckBox {
    margin-left: 10px;
    align-self: center;
}

.singleCheckBox {
    margin-left: 5px;
    align-self: center;
}

.detailGrid {
    border-top: 2px solid lightgray;
}

    .detailGrid > * {
        padding: 4px;
        overflow: auto;
    }

        .detailGrid > *:first-child {
            border-right: 2px solid lightgray;
        }`, "",{"version":3,"sources":["webpack://./src/app/settings/scheduler/scheduler.settings.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;IAEI;QACI,YAAY;QACZ,cAAc;IAClB;;QAEI;YACI,iCAAiC;QACrC","sourcesContent":[".filterStack {\n    justify-content: space-between;\n}\n\n.allCheckBox {\n    margin-left: 10px;\n    align-self: center;\n}\n\n.singleCheckBox {\n    margin-left: 5px;\n    align-self: center;\n}\n\n.detailGrid {\n    border-top: 2px solid lightgray;\n}\n\n    .detailGrid > * {\n        padding: 4px;\n        overflow: auto;\n    }\n\n        .detailGrid > *:first-child {\n            border-right: 2px solid lightgray;\n        }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
